import { AgmMap, MapsAPILoader } from '@agm/core';
import { Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import constant from 'src/app/app.constant';
import { GoogleService } from 'src/app/service/googleService';
import { CommonHttpService } from 'src/app/utils/common-http.service';
import commonLogics from 'src/app/utils/common-logic.service';
import { LocalStorageService } from 'src/app/utils/local-storage.service';

@Component({
  selector: 'app-geocode-auto-complete',
  templateUrl: './geocode-auto-complete.component.html',
  styleUrls: ['./geocode-auto-complete.component.scss']
})
export class GeocodeAutoCompleteComponent implements OnInit {

  isHovered = false;
  zoom: number = 15;

  geocoder: any;
  // initial center position for the map
  lat: any = parseFloat(this.localStorageservice.getItem(constant.localStorage.lat)) || 0;
  lng: any = parseFloat(this.localStorageservice.getItem(constant.localStorage.long)) || 0;
  @Input() addressData: any;
  map: any;
  firstFormGroup: FormGroup;
  mapLoad: boolean = true;
  pickupAddress: string = this.localStorageservice.getItem(constant.localStorage.address);
  private centerChangeSubject = new Subject<any>();
  zoomValue: boolean = true;
  allowPermission: boolean = false;
  latitude: any;
  longitude: any;
  manualAddress: any;
  latlongError: boolean = false;
  constructor(private toaster: ToastrService, public localStorageservice: LocalStorageService, private http: CommonHttpService, public mapsApiLoader: MapsAPILoader, public activeModal: NgbActiveModal, public googleService: GoogleService, private _formBuilder: FormBuilder, private zone: NgZone) {
    this.mapsApiLoader.load().then(() => {
      this.geocoder = new google.maps.Geocoder();
    });

    this.centerChangeSubject.pipe(debounceTime(200)).subscribe((event: any) => {
      this.onMapCenterChange(event);
    });
  }


  ngOnInit(): void {
    this.firstFormGroup = this._formBuilder.group({
      address: [null],
      google_address_dtl: [null],
    })
    // this.getUserLocation();
  }

  onMapIdle() {
    if (!this.zoomValue) {
      this.findAddressByCoordinates();
    }
    this.zoomValue = false;
  }
  onMapCenterChange($event) {
    this.zone.run(() => {
      this.lat = $event?.lat;
      this.lng = $event?.lng;

    });
  }
  mapReadyFunction(map: any) {
    this.map = map;
    this.map.addListener("dragend", () => {
      this.findAddressByCoordinates();
    });
  }


  getUserLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
      });
    }
  }

  handlePermission() {
    navigator.permissions.query({ name: "geolocation" }).then((result) => {
      if (result.state === "granted") {
        this.report(result.state);
        this.getUserLocation();
      } else if (result.state === "prompt") {
        this.report(result.state);
        this.getUserLocation();
      } else if (result.state === "denied") {
        this.report(result.state);
        console.log("denied")
      }
      result.addEventListener("change", () => {
        this.report(result.state);
      });
    });
  }

  report(state) {
    console.log(`Permission ${state}`);
    if (state == 'denied') {
      this.allowPermission = true;
    } else {
      this.allowPermission = false;
    }
  }

  // @ViewChild(AgmMap) agmMap: AgmMap;
  // ngAfterViewInit() {
  //   if (this.agmMap) {
  //     this.agmMap.centerChange.pipe(debounceTime(200)).subscribe((event: any) => {
  //       // Handle the centerChange event here
  //       // console.log('Map center changed:', event);
  //       this.lat = event?.lat;
  //       this.lng = event?.lng;
  //     });
  //   }
  // }

  // changeMapZoom(event) {
  //   this.zoomValue = true;
  // }

  handleMapCenterChange(event: any) {
    this.centerChangeSubject.next(event);
  }
  searchLatLongWise() {
    if (this.latitude && this.longitude) {
      this.zoom = 15;
      this.latlongError = false;
      var latlng = { lat: Number(this.latitude), lng: Number(this.longitude) }
      this.centerChangeSubject.next(latlng);
      setTimeout(() => {
        this.findAddressByCoordinates();
      }, 1500)
    } else {
      this.latlongError = true;
    }
  }
  findAddressByCoordinates() {
    console.log(this.lat, this.lng)
    this.geocoder.geocode({
      'location': {
        lat: this.lat,
        lng: this.lng
      }
    }, (results, status) => {
      console.log(results)
      if (results && results.length > 0) {
        this.onAutocompleteSelected(results[0]);
      }
    });

  }
  onAutocompleteSelected(results) {
    if (
      results &&
      results.address_components &&
      results.address_components.length
    ) {
      this.zone.run(async () => {
        let placeDetails = await this.googleService.googleAddressLoad(results);
        this.pickupAddress = placeDetails.formatted_address;
        this.firstFormGroup.controls['google_address_dtl'].setValue(placeDetails);
      })
    }
  }
  setPickupAddress() {
  }
  lettersOnlyPickup(event: any, field: string) {
    var charCode = event.which;
    if ((charCode <= 90 && charCode >= 48)) {
    }
  }
  async receivedPlaceDetails(placeDetails: any, field: any) {
    this.pickupAddress = placeDetails.formatted_address;

    if (field == 'pickup_address') {
      this.firstFormGroup.controls['address'].setValue(placeDetails.formatted_address);
      this.firstFormGroup.controls['google_address_dtl'].setValue(placeDetails);
      // console.log(placeDetails)
      let latlng = { lat: placeDetails.lat, lng: placeDetails.long }
      this.centerChangeSubject.next(latlng);
    }
  }
  updateUser() {

    let reqJson: any = {
      ...this.firstFormGroup.value,
    }
    reqJson.address = this.manualAddress ? this.manualAddress : this.pickupAddress;
    if (reqJson?.google_address_dtl && reqJson?.google_address_dtl != null) {
      if (reqJson?.google_address_dtl?.country_name) {
        if (reqJson.google_address_dtl && (this.lat != this.localStorageservice.getItem(constant.localStorage.lat) || this.lng != this.localStorageservice.getItem(constant.localStorage.long))) {
          reqJson.google_address_dtl.utc_offset = commonLogics?.getUtcOffset();
          this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.City.AddCity, reqJson.google_address_dtl).subscribe((response: any) => {
            // const cityDataList = response.data;
            if (response.status) {
              this.modifyAddress(reqJson);
            }
          })
        } else {
          this.dismiss();
        }
      } else {
        this.toaster.error('We are unable to get your location. Please contact support - 9500303975.')
      }
    } else {
      this.toaster.error('Please update your address')

    }
  }

  modifyAddress(reqJson: any) {
    this.localStorageservice.addItem(constant.localStorage.address, reqJson.address);
    this.localStorageservice.addItem(constant.localStorage.lat, this.lat);
    this.localStorageservice.addItem(constant.localStorage.long, this.lng);

    reqJson.user_id = this.localStorageservice.getItem(constant.localStorage.user_id);
    reqJson.lat = reqJson.google_address_dtl.lat;
    reqJson.long = reqJson.google_address_dtl.long
    this.http.updateData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.User.DesktopUpdateToken, reqJson).subscribe((response: any) => {
      if (response.status) {
        this.toaster.success('Successfully updated')
        this.dismiss();
      }
    })
  }



  dismiss() {
    this.activeModal.dismiss();
  }

  onMouseEnter() {
    this.isHovered = true;
  }

  onMouseLeave() {
    this.isHovered = false;
  }
}
